module.exports = __webpack_public_path__ + "static/media/clients-01.17294b0c.svg";